import { render, staticRenderFns } from "./NewLunchBreak.vue?vue&type=template&id=700d9acc&scoped=true&"
import script from "./NewLunchBreak.vue?vue&type=script&lang=js&"
export * from "./NewLunchBreak.vue?vue&type=script&lang=js&"
import style0 from "./NewLunchBreak.vue?vue&type=style&index=0&id=700d9acc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d9acc",
  null
  
)

export default component.exports